import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api/axios';

const Field = ({ label, required, children, full }) => (
  <div className="form-group" style={full?{gridColumn:'1/-1'}:{}}>
    <label className="form-label">{label}{required&&<span style={{ color:'var(--red)',marginLeft:3 }}>*</span>}</label>
    {children}
  </div>
);

export default function CustomerForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id && id !== 'new';
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [form, setForm] = useState({
    name:'', customer_type:'RETAIL', contact_person:'', phone:'', alternate_phone:'',
    email:'', address:'', city:'', state:'', pincode:'', gstin:'', pan:'', notes:'',
  });
  const setF = (k,v) => setForm(f=>({...f,[k]:v}));

  useEffect(()=>{
    if(isEdit) api.get(`/sales/customers/${id}/`).then(r=>{ const d=r.data.data||r.data; setForm({ name:d.name||'', customer_type:d.customer_type||'RETAIL', contact_person:d.contact_person||'', phone:d.phone||'', alternate_phone:d.alternate_phone||'', email:d.email||'', address:d.address||'', city:d.city||'', state:d.state||'', pincode:d.pincode||'', gstin:d.gstin||'', pan:d.pan||'', notes:d.notes||'' }); });
  },[id,isEdit]);

  const handleSave = async () => {
    if(!form.name||!form.phone){ setError('Name and phone are required.'); return; }
    setSaving(true); setError('');
    try {
      if(isEdit) await api.patch(`/sales/customers/${id}/`, form);
      else await api.post('/sales/customers/', form);
      navigate('/sales');
    } catch(e){ setError(e.response?.data?.detail||'Failed to save.'); }
    finally { setSaving(false); }
  };

  return (
    <Layout title={isEdit?'Edit Customer':'New Customer'} subtitle="Customer details"
      actions={<button className="btn btn-secondary btn-sm" onClick={()=>navigate('/sales')}>← Back</button>}
    >
      {error&&<div className="error-box" style={{ marginBottom:16 }}>{error}</div>}
      <div className="card" style={{ maxWidth:700 }}>
        <div className="form-grid">
          <Field label="Customer Name *" full><input className="form-input" value={form.name} onChange={e=>setF('name',e.target.value)} placeholder="Full name or company name"/></Field>
          <Field label="Customer Type *">
            <select className="form-input" value={form.customer_type} onChange={e=>setF('customer_type',e.target.value)}>
              {['RETAIL','WHOLESALE','EXPORT','CONTRACTOR'].map(t=><option key={t}>{t}</option>)}
            </select>
          </Field>
          <Field label="Contact Person"><input className="form-input" value={form.contact_person} onChange={e=>setF('contact_person',e.target.value)} placeholder="Contact person name"/></Field>
          <Field label="Phone *"><input className="form-input" value={form.phone} onChange={e=>setF('phone',e.target.value)} placeholder="Phone number"/></Field>
          <Field label="Alternate Phone"><input className="form-input" value={form.alternate_phone} onChange={e=>setF('alternate_phone',e.target.value)} placeholder="Alternate phone"/></Field>
          <Field label="Email"><input className="form-input" type="email" value={form.email} onChange={e=>setF('email',e.target.value)} placeholder="Email address"/></Field>
          <Field label="Address" full><textarea className="form-input" rows={2} value={form.address} onChange={e=>setF('address',e.target.value)} placeholder="Full address"/></Field>
          <Field label="City"><input className="form-input" value={form.city} onChange={e=>setF('city',e.target.value)} placeholder="City"/></Field>
          <Field label="State"><input className="form-input" value={form.state} onChange={e=>setF('state',e.target.value)} placeholder="State"/></Field>
          <Field label="Pincode"><input className="form-input" value={form.pincode} onChange={e=>setF('pincode',e.target.value)} placeholder="Pincode"/></Field>
          <Field label="GSTIN"><input className="form-input" value={form.gstin} onChange={e=>setF('gstin',e.target.value.toUpperCase())} placeholder="GST number" maxLength={15}/></Field>
          <Field label="PAN"><input className="form-input" value={form.pan} onChange={e=>setF('pan',e.target.value.toUpperCase())} placeholder="PAN number" maxLength={10}/></Field>
          <Field label="Notes" full><textarea className="form-input" rows={2} value={form.notes} onChange={e=>setF('notes',e.target.value)} placeholder="Any additional notes"/></Field>
        </div>
        <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
          <button className="btn btn-secondary" onClick={()=>navigate('/sales')}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving?'Saving...':'Save Customer'}</button>
        </div>
      </div>
    </Layout>
  );
}
